/**
 * @fileoverview Make jQuery compatible with Foundation.
 */

// Restore Prototype's $() function.
jQuery.noConflict();

// Do not use PHP-style query string serialization.
jQuery.ajaxSettings.traditional = true;

